import { Link } from 'react-router-dom';
import { SITE } from '@/config/site';
import { topics } from '@/mocks/topics';
import { formatHeat } from '@/utils/format';

export default function HeroSection() {
  const tickerItems = topics.map((t) => t.title);

  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20with%20flowing%20orange%20and%20amber%20light%20ribbons%20on%20deep%20cream%20backdrop%2C%20soft%20blur%20smoke%20texture%2C%20minimal%20editorial%20poster%20style%2C%20artistic%20and%20elegant%2C%20no%20text&width=1600&height=900&seq=chigua-hero-01&orientation=landscape"
        alt="吃瓜观察局首屏背景 - 暖色抽象光带"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <span className="h-2 w-2 rounded-full bg-primary-400 animate-pulse-dot" />
          实时围观中 · 舆论风向每 10 分钟更新一次
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          {SITE.name}
          <span className="mt-3 block text-lg font-medium text-background-100 md:text-2xl">
            {SITE.slogan}
          </span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          热搜话题、网友讨论、舆论风向、评论区实录，我们把这些散落在各处的信息拼成一条清晰的脉络。看看大家都在吵什么，风向怎么变，一起蹲守话题发酵的全过程。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/topics"
            className="w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            围观今日热榜
          </Link>
          <Link
            to="/about"
            className="w-full cursor-pointer whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            了解观察原则
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { icon: 'ri-fire-line', value: '1,286', label: '在追话题' },
            { icon: 'ri-chat-3-line', value: '74.3万', label: '讨论留言' },
            { icon: 'ri-eye-line', value: '2.1亿', label: '累计围观' },
          ].map((s) => (
            <div
              key={s.label}
              className="flex items-center justify-center gap-3 rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-4 backdrop-blur"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/90 text-xl text-background-50">
                <i className={s.icon} />
              </span>
              <span className="flex flex-col text-left">
                <span className="font-heading text-xl font-bold text-background-50">{s.value}</span>
                <span className="text-xs text-background-100/80">{s.label}</span>
              </span>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative z-10 border-t border-background-50/15 bg-foreground-950/60 py-3">
        <div className="flex w-full overflow-hidden">
          <div className="flex shrink-0 animate-marquee items-center gap-8 whitespace-nowrap pr-8">
            {[...tickerItems, ...tickerItems].map((item, i) => (
              <span key={`${item}-${i}`} className="flex items-center gap-2 text-xs text-background-100/90">
                <i className="ri-flashlight-fill text-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}